import PropTypes from 'prop-types'
import {Button, Flex, Text, Link} from '@chakra-ui/react'
import {ExternalLinkIcon} from '@chakra-ui/icons'
import {Trans, useTranslation} from 'react-i18next'
import LearnMoreView from '../../AddSupplierBankAccountIntegrationModal/Views/LearnMoreView'
import SandwichInformationList from '../../SandwichInformationList'
import {
  SwitchHorizontalIcon,
  PadlockOutlineIcon,
  ShieldIcon,
  HistoryIcon,
} from '../../../icons'

const InformationScreen = ({
  goToNextStep,
  displayLearnMore,
  setDisplayLearnMore,
}) => {
  const {t} = useTranslation('connectPayoutAccount')

  const sandwichData = [
    {
      key: 'info',
      icon: SwitchHorizontalIcon,
      description: (
        <Text fontSize="sm" lineHeight="125%">
          {t('modal.information.sandwichList.info.description')}
        </Text>
      ),
    },
    {
      key: 'security',
      icon: PadlockOutlineIcon,
      description: (
        <Text fontSize="sm" lineHeight="125%">
          {t('modal.information.sandwichList.security.description')}
        </Text>
      ),
    },
    {
      key: 'history',
      icon: HistoryIcon,
      description: (
        <Text fontSize="sm" lineHeight="125%">
          {t('modal.information.sandwichList.history.description')}
        </Text>
      ),
    },
    {
      key: 'privacy',
      icon: ShieldIcon,
      description: (
        <Text fontSize="sm" lineHeight="125%">
          <Trans
            t={t}
            i18nKey="modal.information.sandwichList.privacy.description"
            components={{
              a: (
                <Link
                  style={{textDecoration: 'underline'}}
                  color="primary.black"
                  href="https://www.yodlee.com/company/data-promise"
                  rel="nofollow"
                  target="_blank"
                />
              ),
            }}
          />
          <ExternalLinkIcon ml={1} />
        </Text>
      ),
    },
  ]

  if (displayLearnMore) {
    return (
      <Flex
        data-testid="learn-more-view"
        justify="center"
        height="560px"
        className="learn-more"
      >
        <Flex direction="column" width="400px" pt={5} overflowY="auto">
          <LearnMoreView
            isLoading={false}
            startConnecting={() => {}}
            tokenLoaded // Stops ConnectionError message from display
            onboardingFlow // Stops from displaying Connect bank account now button
          />
        </Flex>
      </Flex>
    )
  }

  return (
    <Flex justify="center">
      <Flex flexDirection="column" width="400px" gap={3} pt={10}>
        <Text
          color="black"
          fontWeight="regular"
          fontSize="2xl"
          lineHeight="90%"
        >
          {t('modal.information.title')}
        </Text>
        <Flex flexDirection="column" gap={2} pt={3}>
          <Trans
            t={t}
            i18nKey="modal.information.description"
            components={{
              bold: <b />,
              text: (
                <Text
                  color="black"
                  fontWeight="medium"
                  fontSize="14px"
                  lineHeight="125%"
                />
              ),
            }}
            color="black"
          />
        </Flex>

        <SandwichInformationList
          data-testid="sandwich-info-list"
          data={sandwichData}
          pb={3}
        />

        <Flex gap={5}>
          <Button
            borderRadius="full"
            variant="primary"
            width="200px"
            onClick={goToNextStep}
            _hover={{}}
          >
            {t('modal.buttons.connectYodlee')}
          </Button>
          <Button
            borderRadius="full"
            variant="secondary"
            width="120px"
            onClick={() => setDisplayLearnMore(true)}
            _hover={{}}
          >
            {t('modal.buttons.learnMore')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

InformationScreen.propTypes = {
  goToNextStep: PropTypes.func.isRequired,
  displayLearnMore: PropTypes.bool.isRequired,
  setDisplayLearnMore: PropTypes.func.isRequired,
}

export default InformationScreen
